import InsertChartIcon from "@mui/icons-material/InsertChart";
import SummarizeIcon from "@mui/icons-material/Summarize";
import HistoryIcon from "@mui/icons-material/History";
import ScienceIcon from "@mui/icons-material/Science";
import { Box, Card, Grid, Typography } from "@mui/material";
import { push } from "connected-react-router";
import * as React from "react";
import { useDispatch } from "react-redux";

import { tl } from "../../components/translate";
import Can from "../Policy/Can";
import mixpanelAnalytics from "../../mixpanel-analytics/mixpanelAnalytics";
import EVENT from "../../mixpanel-analytics/event";
import useCurrentResourceCentre from "../../hooks/useCurrentResourceCentre";
import { reportCardStyle, reportsCardContainerStyle } from "./ReportTypesList";

// @ts-expect-error - css
import styles from "./Reports.module.css";

const OtherReport = (): React.ReactNode => {
  const dispatch = useDispatch();
  const rc = useCurrentResourceCentre();

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ ...reportsCardContainerStyle }}>
        <Can policyAccessKey="report:summaryReport">
          <Card
            sx={{ ...reportCardStyle }}
            onClick={() => {
              mixpanelAnalytics.track(EVENT.REPORT_GO_TO_OTHERS_SUMMARY, {
                rcId: rc.id,
                rcName: rc.name
              });
              return dispatch(push("/reports/otherReport/serviceCenterSummaryReport"));
            }}
            data-testmation="summaryReportCard"
          >
            <Grid container>
              <Grid size={8}>
                <Box height="100%" width="100%">
                  <Typography>
                    <Box component="span" fontWeight="700" fontSize="24px">
                      {tl("reports.serviceCenterSummaryReport")}
                    </Box>
                  </Typography>
                </Box>
              </Grid>
              <Grid size={4}>
                <InsertChartIcon className={styles.reportCardChartIcon} />
              </Grid>
            </Grid>
          </Card>
        </Can>
        <Can policyAccessKey="report:hmisLabReport" superAdminPass>
          <Card
            sx={{ ...reportCardStyle }}
            onClick={() => {
              mixpanelAnalytics.track(EVENT.REPORT_GO_TO_OTHERS_HMIS_LAB, {
                rcId: rc.id,
                rcName: rc.name
              });
              return dispatch(push("/reports/otherReport/hmislab"));
            }}
            data-testmation="hmisLabreport"
          >
            <Grid container>
              <Grid size={8}>
                <Box height="100%" width="100%">
                  <Typography component="span" fontWeight="700" fontSize="24px">
                    HMIS Lab Report
                  </Typography>
                </Box>
              </Grid>
              <Grid size={4}>
                <SummarizeIcon className={styles.reportCardChartIcon} />
              </Grid>
            </Grid>
          </Card>
        </Can>
        <Can policyAccessKey="report:hmisMainReport">
          <Card
            sx={{ ...reportCardStyle }}
            onClick={() => {
              mixpanelAnalytics.track(EVENT.REPORT_GO_TO_OTHERS_HMIS_MAIN, {
                rcId: rc.id,
                rcName: rc.name
              });
              return dispatch(push("/reports/otherReport/hmis"));
            }}
            data-testmation="hmisReport"
          >
            <Grid container>
              <Grid size={8}>
                <Box height="100%" width="100%">
                  <Typography component="span" fontWeight="700" fontSize="24px">
                    HMIS Main Report
                  </Typography>
                </Box>
              </Grid>
              <Grid size={4}>
                <SummarizeIcon className={styles.reportCardChartIcon} />
              </Grid>
            </Grid>
          </Card>
        </Can>

        <Can policyAccessKey="report:historyReport" superAdminPass>
          <Card
            sx={{ ...reportCardStyle }}
            onClick={() => {
              mixpanelAnalytics.track(EVENT.REPORT_GO_TO_OTHERS_ACTIVITY_HISTORY, {
                rcId: rc.id,
                rcName: rc.name
              });
              return dispatch(push("/reports/otherReport/history"));
            }}
            data-testmation="historyReport"
          >
            <Grid container>
              <Grid size={8}>
                <Box height="100%" width="100%">
                  <Typography component="span" fontWeight="700" fontSize="24px">
                    Activity Log Report
                  </Typography>
                </Box>
              </Grid>
              <Grid size={4}>
                <HistoryIcon className={styles.reportCardChartIcon} />
              </Grid>
            </Grid>
          </Card>
        </Can>
        <Can policyAccessKey="report:dentalLabReport">
          <Card
            sx={{ ...reportCardStyle }}
            onClick={() => {
              mixpanelAnalytics.track(EVENT.REPORT_GO_TO_OTHERS_HMIS_MAIN, {
                rcId: rc.id,
                rcName: rc.name
              });
              return dispatch(push("/reports/otherReport/labReferralReport"));
            }}
            data-testmation="labRefarralReport"
          >
            <Grid container>
              <Grid size={8}>
                <Box height="100%" width="100%">
                  <Typography component="span" fontWeight="700" fontSize="24px">
                    Dental Lab Referral Report
                  </Typography>
                </Box>
              </Grid>
              <Grid size={4}>
                <ScienceIcon className={styles.reportCardChartIcon} />
              </Grid>
            </Grid>
          </Card>
        </Can>
        <Can policyAccessKey="deny" superAdminPass>
          <Card
            sx={{ ...reportCardStyle }}
            onClick={() => dispatch(push("/reports/otherReport/publicSms"))}
            data-testmation="hmisReport"
          >
            <Grid container>
              <Grid size={8}>
                <Box height="100%" width="100%">
                  <Typography component="span" fontWeight="700" fontSize="24px">
                    Public Sms
                  </Typography>
                </Box>
              </Grid>
              <Grid size={4}>
                <SummarizeIcon className={styles.reportCardChartIcon} />
              </Grid>
            </Grid>
          </Card>
        </Can>
        <Can policyAccessKey="deny" superAdminPass>
          <Card
            sx={{ ...reportCardStyle }}
            onClick={() => dispatch(push("/reports/otherReport/contactSubmissionFormReport"))}
            data-testmation="contactSubmissionFormReport"
          >
            <Grid container>
              <Grid size={8}>
                <Typography fontWeight="700" fontSize="24px">
                  Contact Form Submission Report
                </Typography>
              </Grid>
              <Grid size={4}>
                <SummarizeIcon className={styles.reportCardChartIcon} />
              </Grid>
            </Grid>
          </Card>
        </Can>
      </Box>
    </Box>
  );
};

export default OtherReport;
